

export const Work = [
    {
        id:1,
        name:"ShopHaven-React",
        imgSrc: require('../assets/Images/ShoeMart.png'),
        description:"A React.js project that beautifully displays a curated collection of stylish footwear. Explore a variety of shoes categorized by type, color, category, and price range. Discover the perfect pair that suits your style.",
        tags:["react","Js","sass","css"],
        
        demo:"https://mohammad-jamal.github.io/ShopHaven-Repo/",
        github:"https://github.com/Mohammad-Jamal/ShopHaven-Repo"
    },
    {
        id:2,
        name:"YouTube Clone",
        imgSrc: require('../assets/Images/Youtube-Website.jpg') ,
        description:"I built a YouTube clone with HTML/CSS, integrating video playback, comments, and responsive design, highlighting frontend expertise and user-centric approach.",
        tags:["Html","css"],
        
        demo:"https://mohammad-jamal.github.io/Youtube-Clone/",
        github:"https://github.com/Mohammad-Jamal/Youtube-Clone"
    },
    {
        id:3,
        name:"Facebook Clone",
        imgSrc: require('../assets/Images/Fb-Website.png'),
        description:"Independently created a Facebook clone with HTML/CSS, emphasizing UI/UX design, featuring news feed, user profiles, and real-time updates.",
        tags:["Html","css"],
        
        demo:"https://mohammad-jamal.github.io/Project-FB/",
        github:"https://github.com/Mohammad-Jamal/Project-FB"
        
    },
    {
        id:4,
        name:"HTML Website",
        imgSrc: require('../assets/Images/HTML-Website.jpg'),
        description:"A Website created only using Html. This was my first Html website at the beginning stage of my Web Development journey.",
        tags:["Html"],
        
        demo:"https://mohammadjamal.neocities.org/Event/event",
        github:"https://github.com/Mohammad-Jamal"
       
    },
    
  
] 